import React from 'react';
import { useSelector } from 'react-redux';
import { isLoadingState$ } from '../../redux/selectors';
import './style.css';

export default function GlobalLoading() {
    const isLoading = useSelector(isLoadingState$);

    if (!isLoading) {
        return null;
    }

    return (
        <div className="global-loading">
            <div className="spiner"></div>
            <div className="bar">
                <span className="dot1"></span>
                <span className="dot2"></span>
                <span className="dot3"></span>
            </div>
        </div>
    )
}